import { render, staticRenderFns } from "./PartnershipsList.vue?vue&type=template&id=612832ef&"
import script from "./PartnershipsList.vue?vue&type=script&lang=js&"
export * from "./PartnershipsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports